import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { tqQueryKeys } from "lib/constants";
import { EvendyApi } from "lib/utils/api-utils";

type TicketSalesByMonth = Record<string, number>;

type SalesByTicketType = {
  free: string;
  paid: string;
};

export interface EventAnalytics {
  totalTicketSold: number;
  ticketSalesByMonth: TicketSalesByMonth;
  totalRevenue: number;
  salesByTicketType: SalesByTicketType;
  currentMonthTicketSales: number;
  currentMonthRevenue: number;
}

type GetEventAnalyticsPayload = {
  eventId: number;
};

type EventAnalyticsResult = UseQueryResult<EventAnalytics, Error>;

export function useGetEventAnalytics({ eventId }: GetEventAnalyticsPayload): EventAnalyticsResult {
  return useQuery({
    queryKey: [tqQueryKeys.event.analytics, eventId],
    queryFn: async (): Promise<EventAnalytics> => {
      const res = await EvendyApi.get<EventAnalytics>(`event/manager/analytics/${eventId}`);
      return res.data;
    },
    retry: false,
  });
}
